import { ReactSVG } from "react-svg";

const UserSupportContent = () => {

    const phoneNumber = "09006167070"; // شماره اصلی

    return (
        <div className="w-full min-h-[90vh] bg-gradient-to-r from-[#543389] rounded-xl to-[#8b6bd9] flex items-center justify-center p-6">

            <div className="w-full max-w-3xl bg-white/10 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/20">

                <h1 className="text-white text-3xl font-bold text-center mb-8 font-doran">ارتباط با پشتیبانی</h1>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                    {/* واتساپ - رعنا */}
                    <a
                        href={`https://wa.me/989006167070`}
                        target="_blank"
                        rel="noreferrer"
                        className="group bg-white/20 rounded-xl p-6 flex flex-col items-center justify-center gap-4 shadow-xl hover:bg-white/30 transition-all duration-300 backdrop-blur-lg border border-white/20 cursor-pointer"
                    >
                        <ReactSVG 
                            src={`${process.env.PUBLIC_URL}/assets/images/icons/whatsapp.svg`}
                            className="w-12 text-white"
                        />

                        <div className="flex flex-col gap-2 text-center">
                            <p className="text-white drop-shadow-lg text-xl font-bold">واتساپ</p>
                            <p className="text-white/80 font-medium drop-shadow-lg text-sm mt-1 tracking-wide dir-ltr" dir="ltr">
                                رعنا – خدمات
                            </p>
                            <p className=" text-white/80 font-medium drop-shadow-lg text-base mt-1 tracking-wide dir-ltr" dir="ltr">
                                09006167070
                            </p>
                        </div>
                    </a>

                    {/* واتساپ - رزا */}
                    <a
                        href={`https://wa.me/989194712712`}
                        target="_blank"
                        rel="noreferrer"
                        className="group bg-white/20 rounded-xl p-6 flex flex-col items-center justify-center gap-4 shadow-xl hover:bg-white/30 transition-all duration-300 backdrop-blur-lg border border-white/20 cursor-pointer"
                    >
                        <ReactSVG 
                            src={`${process.env.PUBLIC_URL}/assets/images/icons/whatsapp.svg`}
                            className="w-12 text-white"
                        />

                        <div className="flex flex-col gap-2 text-center">
                            <p className="text-white drop-shadow-lg text-xl font-bold">واتساپ</p>
                            <p className=" text-white/80 font-medium drop-shadow-lg text-sm mt-1 tracking-wide dir-ltr" dir="ltr">
                                رزا – فروش
                            </p>
                            <p className=" text-white/80 font-medium drop-shadow-lg text-base mt-1 tracking-wide dir-ltr" dir="ltr">
                                09194712712
                            </p>
                        </div>
                    </a>

                    {/* واتساپ - پریناز */}
                    <a
                        href={`https://wa.me/989006168080`}
                        target="_blank"
                        rel="noreferrer"
                        className="group bg-white/20 rounded-xl p-6 flex flex-col items-center justify-center gap-4 shadow-xl hover:bg-white/30 transition-all duration-300 backdrop-blur-lg border border-white/20 cursor-pointer"
                    >
                        <ReactSVG 
                            src={`${process.env.PUBLIC_URL}/assets/images/icons/whatsapp.svg`}
                            className="w-12 text-white"
                        />

                        <div className="flex flex-col gap-2 text-center">
                            <p className="text-white drop-shadow-lg text-xl font-bold">واتساپ</p>
                            <p className=" text-white/80 font-medium drop-shadow-lg text-sm mt-1 tracking-wide dir-ltr" dir="ltr">
                                پریناز – آموزش
                            </p>
                            <p className=" text-white/80 font-medium drop-shadow-lg text-base mt-1 tracking-wide dir-ltr" dir="ltr">
                                09006168080
                            </p>
                        </div>
                    </a>

                </div>

                <p className="text-white/70 text-center text-sm mt-10">
                    تیم پشتیبانی ما همیشه آماده پاسخگویی به شماست 🌟
                </p>

            </div>
        </div>
    );
};

export default UserSupportContent;
